// This icon file is generated automatically.
var PBoxPlotOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.88 2.5h-.82a.13.13 0 00-.12.13V6.5H11.5V3.75a.13.13 0 00-.13-.13H2.63a.13.13 0 00-.13.13V6.5H1.06V2.62a.13.13 0 00-.12-.12H.13a.13.13 0 00-.13.13v8.75c0 .06.06.12.13.12h.8c.08 0 .13-.06.13-.13v-3.8H2.5v2.68c0 .07.06.13.13.13h8.75c.06 0 .12-.06.12-.13V7.56h1.44v3.82c0 .06.05.12.12.12h.81c.07 0 .13-.06.13-.13V2.63a.13.13 0 00-.13-.13zM3.62 4.75H5v4.5H3.62v-4.5zm6.75 4.5H6v-4.5h4.38v4.5z", "fill-rule": "nonzero" } }] }, "name": "p-box-plot", "theme": "outlined" };
export default PBoxPlotOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PBoxPlotOutlined.js
// module id = 3256
// module chunks = 0